import { Transition } from "@uirouter/react";
import { includes } from "lodash";
import { useContext, useEffect } from "react";
import { MenuNode, MenuRoute } from "../../components/menu";
import { store } from "../../store";
import { LaunchesDTO } from "../../store/launches/models/dto";
import { LaunchesService } from "../../store/launches/service";
import { And, LeafRole } from "../../utils/and-or-tree";
import { ExternalShellContext } from "../shell/external/context";
import { Footer } from "../shell/external/footer";
import { Header } from "../shell/external/header";
import { ShellRouteNames } from "../shell/route-names";
import { AllLaunches } from "./all";
import { SingleLaunchPage } from "./single";

const names = {
  main: `${ShellRouteNames.shell}.token-onboarding`,
  single: `${ShellRouteNames.shell}.launch-form`,
  externalMain: `${ShellRouteNames.externalShell}.token-onboarding`,
  externalSingle: `${ShellRouteNames.externalShell}.launch-form`,
};

const SetBackground = () => {
  const { setHasBackground } = useContext(ExternalShellContext);
  useEffect(() => {
    setHasBackground(true);
  }, []);
  return null;
};

const allRoute: () => Omit<MenuRoute, "name" | "url"> = () => ({
  views: {
    $default: {
      component: AllLaunches,
    },
    extra: {
      component: SetBackground,
    },
    header: {
      component: Header,
    },
    footer: {
      component: Footer,
    },
  },
  data: {
    title: "projects",
  },
});

const singleRoute: () => Omit<MenuRoute, "name" | "url"> = () => ({
  views: {
    $default: {
      component: SingleLaunchPage,
    },
  },
  data: {
    title: "projects-detail",
  },
  params: {
    id: {
      type: "string",
    },
  },
  resolve: [
    {
      token: "id",
      policy: { when: "EAGER" },
      deps: [Transition],
      resolveFn: (trans: Transition) => trans.params().id,
    },
    {
      token: "item",
      deps: ["id"],
      resolveFn: (id: string) =>
        LaunchesService.getSingle(id).catch((err) => err),
    },
  ],
  redirectTo: async (trans: Transition) => {
    const token = store.getState().auth.login;
    if (
      token.status === "ready" &&
      (includes(token.data.accessToken.roles, "ROLE_ADMIN") ||
        includes(token.data.accessToken.roles, "ROLE_COMMUNITY_MANAGER"))
    ) {
      return trans.router.stateService.target(
        names.main,
        trans.params(),
        trans.options()
      );
    }

    // getAsync tells the resolve to load
    let result:
      | LaunchesDTO.Responses.GetSingle.T
      | Error = await trans.injector().getAsync("item");
    if (result instanceof Error) return names.main;
  },
});

const states: MenuRoute[] = [
  {
    name: names.main,
    url: "/projects",
    resolve: [
      {
        provide: "ctaLink",
        useValue: names.single,
      },
    ],
    ...allRoute(),
  },
  {
    name: names.single,
    url: "/projects/:id",

    ...singleRoute(),
  },
  {
    name: names.externalMain,
    url: "/launches",
    resolve: [
      {
        provide: "ctaLink",
        useValue: names.externalSingle,
      },
    ],
    ...allRoute(),
  },
  {
    name: "tempname1",
    url: "/launch",
    redirectTo: names.externalMain,
    data: {
      title: "",
    },
  },
  {
    name: "tempname2",
    url: "/launch/:id",
    redirectTo: names.externalSingle,
    data: {
      title: "",
    },
  },
  {
    name: names.externalSingle,
    url: "/launches/:id",

    ...singleRoute(),
  },
];

const sidebar: MenuNode.MenuNode = {
  icon: "cryptoToken",
  route: states[0],
  roles: new And(new LeafRole("ROLE_USER"), new LeafRole("ROLE_CRYPTO")),
};

export const TokenOnboardingRoutes = {
  names,
  states,
  sidebar,
};
